import N from "classnames";
import { useRef as w, useEffect as P, isValidElement as T } from "react";
import { isEditMode as B, cardBackground as C, backgroundImage as M, backgroundImageOverlay as R, backgroundVideo as j, backgroundVideoOverlay as L, cardContent as O, title as S, subtitle as z, button as F, buttonText as W } from "./CardBackground.css.js";
import { jsx as e, jsxs as c, Fragment as u } from "react/jsx-runtime";
import { Link as y } from "../link/Link.js";
function q({
  url: n,
  hideButton: t,
  children: r
}) {
  return t && n ? /* @__PURE__ */ e(y, {
    href: n,
    open_in_new_tab: !0,
    children: r
  }) : /* @__PURE__ */ e(u, {
    children: r
  });
}
function Q(n) {
  const {
    element: t,
    children: r,
    className: E,
    attributes: x,
    isEditMode: _,
    backgroundImageElement: I
  } = n, {
    gridProps: i,
    title: m,
    hideTitle: g,
    subtitle: b,
    hideSubtitle: h,
    buttonText: k,
    hideButton: s,
    background: p,
    backgroundVideo: a,
    url: f,
    mobile_hide: $,
    desktop_hide: V,
    customAttributes: d
  } = t, o = I || t.backgroundImage, v = !(g && h && s), l = w(null);
  return P(() => {
    l.current && a && l.current.load();
  }, [l.current, a]), /* @__PURE__ */ e("div", {
    ...d,
    className: N(E, {
      "mobile:hidden": $,
      "desktop:hidden": V,
      [B]: _
    }, C, d == null ? void 0 : d.className),
    style: {
      "--grid-x": i.x + 1,
      "--grid-y": i.y + 1,
      "--grid-w": i.w,
      "--grid-h": i.h,
      ...p && {
        background: p
      },
      ...typeof o == "string" && {
        backgroundImage: `url("${o}")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center"
      }
    },
    ...x,
    children: /* @__PURE__ */ c(q, {
      url: f,
      hideButton: s,
      children: [T(o) && /* @__PURE__ */ c(u, {
        children: [/* @__PURE__ */ e("div", {
          contentEditable: !1,
          className: M,
          children: o
        }), v ? /* @__PURE__ */ e("div", {
          className: R
        }) : null]
      }), a && /* @__PURE__ */ c(u, {
        children: [/* @__PURE__ */ e("video", {
          ref: l,
          contentEditable: !1,
          className: N(j),
          autoPlay: !0,
          muted: !0,
          loop: !0,
          playsInline: !0,
          children: /* @__PURE__ */ e("source", {
            src: a
          })
        }), v ? /* @__PURE__ */ e("div", {
          className: L
        }) : null]
      }), /* @__PURE__ */ c("div", {
        className: O,
        children: [m && !g ? /* @__PURE__ */ e("div", {
          className: S,
          children: m
        }) : null, b && !h ? /* @__PURE__ */ e("div", {
          className: z,
          children: b
        }) : null]
      }), k && !s ? /* @__PURE__ */ e(y, {
        href: f,
        open_in_new_tab: !0,
        className: F,
        children: /* @__PURE__ */ e("span", {
          className: W,
          children: k
        })
      }) : null, /* @__PURE__ */ e("div", {
        style: {
          display: "none"
        },
        children: r
      })]
    })
  });
}
export {
  Q as CardBackgroundElement
};
